import React from 'react';
import { omitBy } from 'lodash';
import { toPx } from '../../utils/to-px';
import { toSafeColor } from '../../utils/to-safe-color';
import { SectionItem } from '../section-item';
import { useRemainingWidth, WidthProvider } from '../width-context';
export function Column({ siblingsCount, direction = 'ltr', verticalAlign = 'top', ...rest }) {
    const props = { ...rest, verticalAlign };
    let classesName = 'mj-outlook-group-fix';
    if (props.cssClass) {
        classesName += ` ${props.cssClass}`;
    }
    const remainingWidth = useRemainingWidth({
        width: props.width,
        round: props.forceWidth,
    });
    return (React.createElement(WidthProvider, { value: remainingWidth },
        React.createElement(SectionItem, { verticalAlign: verticalAlign },
            React.createElement("div", { className: classesName, style: {
                    fontSize: '0px',
                    textAlign: 'left',
                    direction,
                    display: 'inline-block',
                    verticalAlign,
                    width: props.forceWidth ? props.width : '100%',
                    maxWidth: props.width,
                } }, hasGutter(props) ? (React.createElement(RenderGutter, { ...props })) : (React.createElement(RenderColumn, { ...props }))))));
}
function RenderGutter(props) {
    const { backgroundColor, border, borderRadius, padding, paddingBottom, paddingLeft, paddingRight, paddingTop, verticalAlign, } = props;
    const remainingWidth = useRemainingWidth({
        padding,
        paddingLeft,
        paddingRight,
        border,
    });
    const style = {
        backgroundColor: toSafeColor(backgroundColor),
        border,
        borderRadius: toPx(borderRadius),
        verticalAlign,
        // NOTE: client side and server side react style attribute merging behaves differently.
        // So to make it 1:1 in both cases if property doesn't exist we don't need to set it.
        ...omitBy({
            padding,
            paddingTop,
            paddingRight,
            paddingBottom,
            paddingLeft,
        }, (value) => !value),
    };
    return (React.createElement("table", { border: "0", cellPadding: 0, cellSpacing: 0, role: "presentation", width: "100%" },
        React.createElement("tbody", null,
            React.createElement("tr", null,
                React.createElement("td", { style: style },
                    React.createElement(WidthProvider, { value: remainingWidth },
                        React.createElement(RenderColumn, { ...props })))))));
}
function RenderColumn(props) {
    const { innerBackgroundColor, backgroundColor, border, borderRadius, verticalAlign, children, } = props;
    const remainingWidth = useRemainingWidth({
        border,
    });
    const withGutter = hasGutter(props);
    return (React.createElement("table", { border: "0", cellPadding: 0, cellSpacing: 0, role: "presentation", style: withGutter
            ? { backgroundColor: toSafeColor(innerBackgroundColor) }
            : {
                backgroundColor: toSafeColor(backgroundColor),
                border,
                borderRadius: toPx(borderRadius),
                verticalAlign,
            }, width: "100%" },
        React.createElement("tbody", null, withGutter ? (children) : (React.createElement(WidthProvider, { value: remainingWidth }, children)))));
}
function hasGutter(props) {
    return [
        props.paddingLeft,
        props.paddingRight,
        props.paddingTop,
        props.paddingBottom,
        props.padding,
    ].some((_) => _ !== null && _ !== undefined);
}
//# sourceMappingURL=column.js.map